import { CallToAction, Container, Header, Heading, TextAndMedia } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import StartSimulationButton from 'components/start-simulation-button/StartSimulationButton'
import styles from './UspsFairPrice.module.scss'
import parse from 'html-react-parser'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import { useGetLanguage } from 'hooks/useGetLanguage'
import UspTestimonials from 'features/usps/components/testimonials/UspTestimonials'
import BoltChart from 'features/usps/fair-price/components/charts/BoltChart'
import OtherSupplierChart from 'features/usps/fair-price/components/charts/OtherSupplierChart'

const UspsFairPrice = () => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'price' })
  const language = useGetLanguage()

  return (
    <main>
      <Header title={t('header.title')} color="dark" shape="s3">
        <p>{t('header.description')}</p>
      </Header>

      <TextAndMedia
        inverse
        title={t('intro.title')}
        media={{
          type: 'image',
          imageBehaviour: '1-1',
          props: { publicId: '/website/usps/price', fill: true, alt: '' }
        }}
      >
        <p>{t('intro.description')}</p>
      </TextAndMedia>

      <Container as="section" classnames={{ content: styles.comparison }}>
        <Heading as="h2" variant="d3" className={styles['comparison-title']}>
          {t('comparison.title')}
        </Heading>
        <p className={styles['comparison-description']}>{t('comparison.description')}</p>
        <div className={styles['comparison-charts']}>
          <BoltChart />
          <OtherSupplierChart />
        </div>
      </Container>

      <TextAndMedia
        inverse
        title={t('invoice.title')}
        media={{
          type: 'node',
          props: {
            node: (
              <div className={styles['chart-wrapper']}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="44.35 44.35 242.65 242.65" className={styles.chart}>
                  <path
                    d="M228.687 129.291C208.593 94.487 164.091 82.5624 129.287 102.656C94.4831 122.751 82.5586 167.253 102.652 202.057C122.747 236.861 167.249 248.785 202.053 228.691C236.857 208.597 248.781 164.095 228.687 129.291ZM270.7 105.034C304.19 163.041 284.316 237.214 226.309 270.704C168.303 304.194 94.1295 284.32 60.6394 226.313C27.1495 168.307 47.0242 94.1335 105.03 60.6434C163.037 27.1533 237.21 47.0281 270.7 105.034Z"
                    fill="#43006D"
                  />
                  <path
                    d="M246.821 75.5431C256.279 84.0586 264.339 94.0094 270.702 105.031L228.689 129.287C224.871 122.674 220.037 116.703 214.363 111.594L246.821 75.5431Z"
                    fill="#00F0C8"
                  />
                  <path
                    d="M270.709 105.034C283.515 127.214 288.969 152.879 286.291 178.35C283.614 203.821 272.943 227.79 255.806 246.823C238.668 265.856 215.945 278.975 190.893 284.3C165.842 289.625 139.746 286.884 116.349 276.467L136.082 232.15C150.12 238.399 165.776 240.046 180.807 236.851C195.838 233.656 209.472 225.784 219.754 214.365C230.037 202.945 236.441 188.563 238.047 173.28C239.654 157.997 236.379 142.598 228.696 129.29L270.709 105.034Z"
                    fill="#9C32FF"
                  />
                </svg>

                <ul className={styles.legend}>
                  <li>
                    <span className={styles.indicator} />
                    <span>{t('invoice.legend.producer')}</span>
                  </li>
                  <li>
                    <span className={styles.indicator} />
                    <span>{t('invoice.legend.netTariffs')}</span>
                  </li>
                  <li>
                    <span className={styles.indicator} />
                    <span>{t('invoice.legend.platformCost')}</span>
                  </li>
                </ul>
              </div>
            )
          }
        }}
      >
        <p className={styles['invoice-description']}>{t('invoice.description')}</p>
      </TextAndMedia>

      <TextAndMedia
        title={t('injection.title')}
        media={{
          type: 'image',
          imageBehaviour: '1-1',
          props: { publicId: '/website/usps/fun', fill: true, alt: '' }
        }}
      >
        <p>{parse(t('injection.description'))}</p>
        <Link representation="button" variant="secondary" href={routes(language).injectionTariff} trailingIcon="chevronRight">
          {t('injection.action')}
        </Link>
      </TextAndMedia>

      <CallToAction title={t('cta.title')} color="dark" shape="s6" action={<StartSimulationButton />}>
        <p>{t('cta.description')}</p>
      </CallToAction>

      <UspTestimonials
        ratings={{ googleReviews: true }}
        reviews={t('testimonials.reviews', { returnObjects: true }) as Array<{ text: string; author: string }>}
      />
    </main>
  )
}

export default UspsFairPrice
